import {TypeAttributionMarcheLot} from './TypeAttributionMarcheLot';
export class TypeResultatAttribution {

	public infructueux: string;

	public attribue: TypeAttributionMarcheLot;

	public sansSuite: string;

	constructor() {
		 		this.infructueux = null;
		this.attribue = new TypeAttributionMarcheLot();
		this.sansSuite = null;

	}
}
